import { analyticAverageTimeActions } from 'store/actions';
import { IAnalyticAverageTimeMeta } from 'store/actions/analytics/averageTime';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticAverageTimeMeta, GenericResponse>(
  analyticAverageTimeActions,
);
